import dayjs from "dayjs";
import { BASE_URL } from "../utils";

export const BOROUGH_OPTIONS = ["Manhattan", "Bronx", "Brooklyn", "Queens", "Staten Island"];

export const formatDate = (value) => {
  if (!value) return "-";
  const d = dayjs(value);
  return d.isValid() ? d.format("MM/DD/YYYY") : String(value);
};

export const formatMoney = (value) => {
  const num = Number(value || 0);
  if (!Number.isFinite(num)) return "-";
  return num.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
};

export const safeText = (value, fallback = "-") => {
  if (value === null || value === undefined) return fallback;
  const str = String(value).trim();
  return str ? str : fallback;
};

export const buildPdfLink = (row) => {
  if (!row) return { label: "No PDF", href: null, status: "none" };
  if (row.deed_pdf_downloaded === 0) {
    return { label: "PDF pending", href: null, status: "pending" };
  }
  if (row.deed_pdf_local_path) {
    const raw = String(row.deed_pdf_local_path || "").trim();
    if (!raw) return { label: "No PDF", href: null, status: "none" };
    // Normalize Windows/absolute paths to a web-served filename.
    const normalized = raw.replace(/\\\\/g, "/").replace(/\\/g, "/");
    const fromDeed = normalized.includes("/deed_pdfs/")
      ? normalized.slice(normalized.lastIndexOf("/deed_pdfs/") + "/deed_pdfs/".length)
      : normalized.split("/").pop();
    const fileName = fromDeed || normalized;
    const path = fileName.startsWith("/") ? fileName : `/deed_pdfs/${fileName}`;
    return { label: "View PDF", href: `${BASE_URL}${path}`, status: "local" };
  }
  if (row.deed_pdf_url) {
    return { label: "View on ACRIS", href: row.deed_pdf_url, status: "external" };
  }
  return { label: "No PDF", href: null, status: "none" };
};

export const confidencePill = (confidence) => {
  const value = String(confidence || "").toUpperCase();
  if (value === "STRONG") return "badge-pill badge-green";
  if (value === "WEAK") return "badge-pill badge-amber";
  return "badge-pill badge-neutral";
};

export const formatConfidenceLabel = (confidence) => {
  const value = String(confidence || "").toUpperCase();
  if (!value) return "NA";
  if (value === "EXACT_ALT_FORMAT") return "EXACT-ALT";
  return value;
};

export const ownershipPill = (value) => {
  if (value === 1 || value === true || value === "1") return "badge-pill badge-green";
  if (value === 0 || value === false || value === "0") return "badge-pill badge-rose";
  return "badge-pill badge-neutral";
};
